import React, { useState, useRef } from 'react';
import AuthBtn from '../../../../component/AuthBtn';
import { Link } from 'react-router-dom';
import Icon from '../../../../component/Icon';
import { Formik } from 'formik';
import Validate from '../../../../component/Validate';
import Inputbox from '../../../../component/Inputbox';
import { addProductValidation } from '../../../../utils/inputValidation';
import { useDispatch, useSelector } from 'react-redux';
import * as actionCreators from '../../../../store/actionCreators/index';
import PreviewImage from '../../../../component/PreviewImage';
import { getImageUrl } from '../../../../utils/getImageUrl';

function AddProduct() {
  const dispatch = useDispatch();
  const fileRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState('');

  const state = useSelector((state) => state.auth.token);

  return (
    <div className='p-4'>
      {/* Header and button */}
      <div className='flex  justify-between pb-4 '>
        <h1 className='text-[1.5rem] font-semibold font-Poppins'>Products</h1>
        <Link to='/admin/products'>
          <AuthBtn
            title='View All products'
            className='bg-[#358280] text-white t rounded-md px-3 py-1 ml-auto'
          />
        </Link>
      </div>
      {/* Creating container */}
      <div className='bg-white pl-[3rem] pb-8 shadow-2xl'>
        <h1 className='font-poppins font-[500] text-[1.25rem] text-gray-400 py-2'>
          Create New Post
        </h1>
        <div className='w-full h-full'>
          <Formik
            initialValues={{
              category: '',
              title: '',
              price: '',
              image: null,
              description: '',
            }}
            validate={addProductValidation}
            onSubmit={(values, { resetForm }) => {
              dispatch(actionCreators.addProduct(values, setLoading, state));
              resetForm();
            }}
            className='w-full h-full'
          >
            {/* Categoreis and title box */}
            {(props) => (
              <form action='' onSubmit={props.handleSubmit}>
                <div className='flex gap-8'>
                  <div
                    style={{ flex: 1 }}
                    className='flex flex-col gap-y-4 font-Poppins font-[400] text-[0.9rem]'
                  >
                    {/* Categories */}
                    <div className='flex'>
                      <label className='block flex-1'>Select Category</label>
                      <select
                        name='category'
                        onChange={props.handleChange}
                        style={{ flex: 1 }}
                        className='bg-gray-300 block border-white'
                      >
                        <option value='none'>None</option>
                        <option value='Cakes'>Cakes</option>
                        <option value='Bakery'>Bakery Foods</option>
                      </select>
                    </div>
                    <Validate message={props.errors.category} />
                    {/* Title */}
                    <div className='flex '>
                      <label className='block flex-1 '>Title</label>
                      <input
                        name='title'
                        onChange={props.handleChange}
                        type='text'
                        style={{ flex: 1 }}
                        className=' block border-2 border-gray-400'
                      />
                    </div>
                    <Validate message={props.errors.title} />
                    {/* Price */}
                    <div className='flex'>
                      <label className='block flex-1'>Price</label>
                      <input
                        name='price'
                        onChange={props.handleChange}
                        type='number'
                        style={{ flex: 1 }}
                        className=' block border-2 border-gray-400'
                      />
                    </div>
                    <Validate message={props.errors.price} />
                    {/* DESCRIPTION */}
                    <div className=''>
                      <label className='block '>Description</label>
                      <textarea
                        name='description'
                        onChange={props.handleChange}
                        type='number'
                        className=' block p-3 text-gray-400   bg-[#f3f2f2]
                 w-full'
                      />
                    </div>
                    <Validate message={props.errors.description} />
                  </div>

                  {/* Upload images box */}
                  <button
                    type='button'
                    onClick={() => {
                      fileRef.current.click();
                    }}
                    style={{ flex: 1 }}
                    className=''
                  >
                    <label
                      htmlFor='image'
                      className='flex cursor-pointer justify-center items-center w-[14rem] h-[14rem] bg-[#f3f2f2] rounded-md active:scale-[0.7] hover:scale-[1.04] transition ease-out '
                    >
                      <div className='w-[5rem] h-[5rem] flex justify-center items-center  bg-white'>
                        <Icon
                          name='plus-solid'
                          className='w-[2rem] h-[2rem] fill-gray-400'
                        />
                      </div>
                    </label>
                    <h1>Upload Image</h1>

                    {<PreviewImage file={imgUrl} />}
                    <Validate message={props.errors.image} />

                    <input
                      ref={fileRef}
                      name='image'
                      onChange={(e) => {
                        // setImgUrl(e.target.files[0]);
                        const reader = new FileReader();
                        reader.addEventListener('load', () => {
                          setImgUrl(reader.result);
                        });
                        reader.readAsDataURL(e.target.files[0]);
                        props.setFieldValue('image', e.currentTarget.files[0]);
                      }}
                      id='image'
                      type='file'
                      className='hidden'
                      value={props.image}
                    />
                  </button>
                </div>
                <div className='flex gap-2 font-Poppins pt-[2rem] '>
                  <AuthBtn
                    title='Save'
                    className='bg-[#358280] hover:bg-[#2a6362] transition ease-out active:scale-[0.7] px-5 text-white py-[0.15rem] '
                  />
                  <AuthBtn
                    title='Cancel'
                    className='bg-[#C92C33] px-[1.2rem] active:scale-[0.7] transition ease-out hover:bg-[#90191f] text-white py-[0.15rem] '
                  />
                </div>
              </form>
            )}
          </Formik>
        </div>
        {/* Button container */}
      </div>
    </div>
  );
}

export default AddProduct;
